/**
 * File helper utilities - simplified version for build compatibility
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
/**
 * 파일을 텍스트로 읽는 헬퍼 함수
 */ export var readFileAsText = function(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
            return resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(file);
    });
};
/**
 * 파일 확장자를 기반으로 파일 타입을 판단하는 함수
 */ export var getFileType = function(fileName) {
    var _fileName_split_pop;
    var extension = ((_fileName_split_pop = fileName.split('.').pop()) === null || _fileName_split_pop === void 0 ? void 0 : _fileName_split_pop.toLowerCase()) || '';
    var typeMap = {
        'js': 'javascript',
        'ts': 'typescript',
        'jsx': 'javascript',
        'tsx': 'typescript',
        'json': 'json',
        'md': 'markdown',
        'txt': 'text',
        'html': 'html',
        'css': 'css',
        'py': 'python',
        'java': 'java',
        'cpp': 'cpp',
        'c': 'c'
    };
    return typeMap[extension] || 'text';
};
/**
 * 파일 크기를 읽기 쉬운 형태로 변환하는 함수
 */ export var formatFileSizeHelper = function(bytes) {
    var units = [
        'B',
        'KB',
        'MB',
        'GB'
    ];
    var size = bytes;
    var unitIndex = 0;
    while(size >= 1024 && unitIndex < units.length - 1){
        size /= 1024;
        unitIndex++;
    }
    return "".concat(size.toFixed(1), " ").concat(units[unitIndex]);
};
/**
 * 파일 트리를 플랫 구조로 변환하는 함수
 */ export var flattenFileTree = function(tree) {
    var basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tree[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            var fullPath = basePath ? "".concat(basePath, "/").concat(node.name) : node.name;
            result.push(_object_spread_props(_object_spread({}, node), {
                id: fullPath
            }));
            if (node.type === 'directory' && node.children) {
                var _result;
                (_result = result).push.apply(_result, _to_consumable_array(flattenFileTree(node.children, fullPath)));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
};
/**
 * 파일 확장자에 따른 아이콘과 색상 정보를 반환하는 함수
 */ export var getFileIcon = function(fileName) {
    var _fileName_split_pop;
    var extension = ((_fileName_split_pop = fileName.split('.').pop()) === null || _fileName_split_pop === void 0 ? void 0 : _fileName_split_pop.toLowerCase()) || '';
    var iconMap = {
        'js': {
            icon: 'FileCode',
            color: 'text-yellow-500'
        },
        'ts': {
            icon: 'FileCode',
            color: 'text-blue-500'
        },
        'jsx': {
            icon: 'FileCode',
            color: 'text-cyan-500'
        },
        'tsx': {
            icon: 'FileCode',
            color: 'text-blue-500'
        },
        'json': {
            icon: 'FileText',
            color: 'text-green-500'
        },
        'md': {
            icon: 'FileText',
            color: 'text-purple-500'
        },
        'txt': {
            icon: 'FileText',
            color: 'text-gray-500'
        },
        'html': {
            icon: 'FileCode',
            color: 'text-orange-500'
        },
        'css': {
            icon: 'FileCode',
            color: 'text-pink-500'
        },
        'py': {
            icon: 'FileCode',
            color: 'text-green-600'
        },
        'java': {
            icon: 'FileCode',
            color: 'text-red-500'
        },
        'cpp': {
            icon: 'FileCode',
            color: 'text-blue-600'
        },
        'c': {
            icon: 'FileCode',
            color: 'text-blue-600'
        },
        'package': {
            icon: 'Package',
            color: 'text-brown-500'
        }
    };
    return iconMap[extension] || {
        icon: 'FileText',
        color: 'text-gray-500'
    };
};
/**
 * 파일 시스템 트리에 파일을 추가하는 함수 (WebContainer API 호환)
 */ export var addFileToTree = function(tree, pathParts, contents) {
    // 경로가 비어있는 경우 처리
    if (!pathParts || pathParts.length === 0) {
        console.warn('[addFileToTree] 경로가 비어있습니다. 파일을 추가할 수 없습니다.');
        return;
    }
    try {
        // 파일 경로에서 첫 번째 디렉토리(루트 프로젝트 폴더)를 제거하여 파일을 루트에 직접 배치
        if (pathParts.length > 1) {
            pathParts = pathParts.slice(1);
        }
        // 빈 경로가 된 경우 처리
        if (pathParts.length === 0) {
            console.warn('[addFileToTree] 경로 처리 후 경로가 비어있습니다. 파일을 추가할 수 없습니다.');
            return;
        }
        if (pathParts.length === 1) {
            // 리프 노드 (파일)인 경우
            tree[pathParts[0]] = {
                file: {
                    contents: contents
                }
            };
            console.log("[addFileToTree] 파일 추가: ".concat(pathParts[0]));
        } else if (pathParts.length > 1) {
            // 디렉토리인 경우
            var dirName = pathParts[0];
            var restPath = pathParts.slice(1);
            // 디렉토리가 존재하지 않으면 생성
            if (!tree[dirName]) {
                tree[dirName] = {
                    directory: {}
                };
                console.log("[addFileToTree] 디렉토리 생성: ".concat(dirName));
            }
            // 디렉토리 구조 확인
            if (!tree[dirName] || !('directory' in tree[dirName])) {
                console.error("[addFileToTree] 오류: ".concat(dirName, "은 디렉토리가 아니거나 존재하지 않습니다."));
                return;
            }
            // 재귀적으로 다음 경로 처리
            addFileToTree(tree[dirName].directory, restPath, contents);
        }
    } catch (error) {
        console.error('[addFileToTree] 파일 추가 중 오류 발생:', error);
    }
};
/**
 * 기본 package.json 파일 생성
 */ export var createDefaultPackageJson = function(folderName) {
    return JSON.stringify({
        name: folderName.toLowerCase().replace(/\s+/g, '-'),
        version: '1.0.0',
        private: true,
        scripts: {
            dev: 'npx --yes http-server . -p $PORT -c-1 --cors',
            start: 'npx --yes http-server . -p $PORT -c-1 --cors'
        }
    }, null, 2);
};
export default {
    readFileAsText: readFileAsText,
    getFileType: getFileType,
    formatFileSizeHelper: formatFileSizeHelper,
    flattenFileTree: flattenFileTree,
    getFileIcon: getFileIcon,
    addFileToTree: addFileToTree,
    createDefaultPackageJson: createDefaultPackageJson
};
